<cdk-tree
  [dataSource]="nestedDataSource"
  [treeControl]="nestedTreeControl"
  class="ui-tree-nav__root"
  [class.ui-tree-nav__root--horizontal]="mode === 'horizontal'"
  [trackBy]="trackById"
  >
  <cdk-tree-node *cdkTreeNodeDef="let node" cdkTreeNodeToggle>
    <li class="ui-tree-nav__node" data-cy="tree-nav-node">
      @if (handleNavigation) {
        <a
          [routerLink]="node.link"
          [queryParamsHandling]="node.queryParamsHandling"
          [queryParams]="node.queryParams"
          routerLinkActive="ui-tree-nav__node--active"
          class="ui-tree-nav__node-item ui-body-1 [ relative ]"
          [class.ui-tree-nav__node-item--with-badge]="node.badge && node.badge !== '0'"
          >
          @if (node.icon) {
            <campus-icon [svgIcon]="node.icon" class="ui-tree-nav__node-icon"></campus-icon>
          }
          <span class="ui-tree-nav__node-label">{{ node.title }}</span>
          @if (node.badge && node.badge !== '0') {
            <span
              class="ui-tree-nav__node-badge"
              data-cy="tree-nav-node-badge"
              @fadeIn
              >
              {{ node.badge }}
            </span>
          }
          @if (indicatorsByNodeId && indicatorsByNodeId[node.id]) {
            <campus-badge
              size="small"
              class="[ absolute right-2xs top-s ]"
            ></campus-badge>
          }
        </a>
      } @else {
        <div
          class="ui-tree-nav__node-item [ relative ]"
          [class.ui-body-1]="node?.data?.depth > 0 || (mode === 'horizontal' && !node.hasChildren)"
          [class.ui-tree-nav__node--active]="node.id === activeNode?.id"
          (click)="toggleNode(node)"
          >
          @if (node.icon) {
            <campus-icon [svgIcon]="node.icon" class="ui-tree-nav__node-icon"></campus-icon>
          }
          <span class="ui-tree-nav__node-label">{{ node.title }}</span>
          @if (indicatorsByNodeId && indicatorsByNodeId[node.id]) {
            <campus-badge
              size="small"
              class="[ absolute right-2xs top-xs ]"
            ></campus-badge>
          }
        </div>
      }

    </li>
  </cdk-tree-node>

  <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: hasChildren">
    <li
      data-cy="tree-nav-list-item"
      class="ui-tree-nav__node"
      [class.ui-tree-nav__node--closed]="!nestedTreeControl.isExpanded(node)"
      >
      @if (handleNavigation) {
        <a
          data-cy="tree-nav-node"
          class="ui-tree-nav__node-item ui-body-1 [ relative ]"
          [routerLink]="node.link"
          [queryParamsHandling]="node.queryParamsHandling"
          routerLinkActive="router-link-active"
          routerLinkActive="ui-tree-nav__node--active"
          cdkTreeNodeToggle
          [class.ui-tree-nav__node-item--with-children]="hasChildren(0, node)"
          (click)="toggleNode(node)"
          >
          @if (node.icon) {
            <campus-icon [svgIcon]="node.icon" class="ui-tree-nav__node-icon"></campus-icon>
          }
          <span class="ui-tree-nav__node-label">{{ node.title }}</span>
          @if (hasChildren(0, node)) {
            <campus-icon
              class="ui-tree-nav__node__arrow"
              svgIcon="expand-more"
              (click)="toggleNode(node)"
              campusClickPreventDefault
              campusClickStopPropagation
            ></campus-icon>
          }
          @if (indicatorsByNodeId && indicatorsByNodeId[node.id]) {
            <campus-badge
              size="small"
              class="[ absolute right-2xs top-s ]"
            ></campus-badge>
          }
        </a>
      } @else {
        <div
          cdkTreeNodeToggle
          (click)="toggleNode(node)"
          class="ui-tree-nav__node-item [ relative ]"
          [class.ui-tree-nav__node--active]="node.id === activeNode?.id"
          >
          @if (node.icon) {
            <campus-icon [svgIcon]="node.icon" class="ui-tree-nav__node-icon"></campus-icon>
          }
          <span class="ui-tree-nav__node-label">{{ node.title }}</span>
          @if (hasChildren(0, node)) {
            <campus-icon
              class="ui-tree-nav__node__arrow"
              svgIcon="expand-more"
              (click)="toggleNode(node)"
            ></campus-icon>
          }
          @if (indicatorsByNodeId && indicatorsByNodeId[node.id]) {
            <campus-badge
              size="small"
              class="[ absolute right-2xs top-s ]"
            ></campus-badge>
          }
        </div>
      }
      <ul
        [@.disabled]="!animate"
        [@toggleOpened]="
          nestedTreeControl.isExpanded(node) ? CollapsibleAnimationState.OPENED : CollapsibleAnimationState.CLOSED
        "
        class="ui-tree-nav__subtree"
        data-cy="tree-nav-node-subtree"
        >
        <ng-container cdkTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </cdk-nested-tree-node>
</cdk-tree>
